export default {
      id: "app-store-usage",
      viewBox: "0 0 2150 637",
      url: "/assets/svg/" + "sprite.svg#app-store-usage",
      toString: function () {
        return this.url;
      }
    }